export default __webpack_public_path__ + "static/media/FinanceRealCase2-mobile-en.46071a3d.jpg";